module.exports = __webpack_public_path__ + "img/icon2.fe167167.svg";